<ng-template>
  <div class="container mat-elevation-z2">
    <div class="header">
      <span class="h3 title">{{ 'TOOLBAR.USERMENU.NOTIFICATIONS' | translate }}</span>
      <div class="h5 mark-as-read" (click)="markAllAsRead()" matRipple>
        <mat-icon svgIcon="check_circle" class="checkmark"></mat-icon>
        {{ 'TOOLBAR.USERMENU.NOTIFICATIONS_PANEL.MARK_ALL_READ' | translate }}
      </div>
    </div>

    <div linScrollable class="list">
      @if (!isLoaded) {
      <div class="notifications-empty">
        <mat-spinner strokeWidth="2" diameter="30" color="accent"></mat-spinner> &nbsp;
        <span>{{ 'TOOLBAR.USERMENU.NOTIFICATIONS_PANEL.LOADING' | translate }}</span>
      </div>
      } @if (isLoaded && !notifications.length) {
      <div class="notifications-empty">{{ 'TOOLBAR.USERMENU.NOTIFICATIONS_PANEL.NO_NOTIFICATIONS' | translate }}</div>
      } @if (notifications.length) { @for (notification of notifications; track trackById($index, notification)) {
      <lin-notification
        [isRead]="markedAsRead[notification.id] || notification.isRead"
        [notification]="notification"
        (markRead)="emitMarkRead(notification.id)"
      ></lin-notification>
      } }
    </div>

    <!-- <div class="notif_footer" *ngIf="notifications.length">
     <span class="h3 title">{{ 'TOOLBAR.USERMENU.NOTIFICATIONS_PANEL.SEE_MORE' | translate }}</span>
    </div> -->
  </div>
</ng-template>
